import { useNextRouter } from '@/data/Content/_NextRouter';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';

export const useGetOriginPathQuery = () => {
	const router = useNextRouter();
	const { query } = router;
	const { origin } = query;
	return valueIsString(origin) ? origin : undefined;
};
